<p-table data-identifier="audit-report-table" [value]="auditReports"
         [lazy]="true" [lazyLoadOnInit]="false" (onLazyLoad)="customSort($any($event))" [loading]="isLoading"
         sortMode="single" sortField="creationAudit.dateCreated" [sortOrder]="-1" [totalRecords]="totalItems"
         [scrollable]="true" scrollHeight="650px" [tableStyle]="{'min-width': '65rem'}">
    <ng-template pTemplate="header">
        <tr>
            <th scope="col" class="table-col-15" pSortableColumn="reportName" [pSortableColumn]="'reportName'" data-identifier="auditreport-header-reportName">
                Report Name
                <p-sortIcon field="reportName"></p-sortIcon>
            </th>
            <th scope="col" class="table-col-12" pSortableColumn="creationAudit.dateCreated" data-identifier="auditreport-header-datecreated">
                Date Requested
                <p-sortIcon field="creationAudit.dateCreated"></p-sortIcon>
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-fromdate">
                From Date
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-todate">
                To Date
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-enterprise" *ngIf="!isOrgAdminApp()">
                Organization
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-eventcategory">
                Event Category
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-eventname">
                Event Name
            </th>
            <th scope="col" class="table-col-12" data-identifier="auditreport-header-datedelivered">
                Delivery Date
            </th>
            <th scope="col" class="table-col-20" data-identifier="auditreport-header-filename">
                File
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-report>
        <tr>
            <td data-identifier="auditreport-reportname">{{ report.reportName }}</td>
            <td data-identifier="auditreport-datecreated">{{ report.dateCreated | formatDateArray }}</td>
            <td data-identifier="auditreport-fromndate">{{ report.fromDate | formatDateArray }}</td>
            <td data-identifier="auditreport-todate">{{ report.toDate | formatDateArray }}</td>
            <td data-identifier="auditreport-enterprise" *ngIf="!isOrgAdminApp()">{{ report.enterpriseName }}</td>
            <td data-identifier="auditreport-eventcategory">{{ report.eventCategory | titlecase }}</td>
            <td data-identifier="auditreport-eventname">{{ report.eventName }}</td>
            <td data-identifier="auditreport-datedelivered">{{ report.dateDelivered | formatDateArray }}</td>
            <td data-identifier="auditreport-filename" [ngSwitch]="true">
                <ng-container *ngSwitchCase="report.status === AuditReportStatus.PROCESSING">
                    <i class="fa fa-spinner fa-spin me-1"></i>{{ report.status | titlecase }}
                </ng-container>
                <ng-container *ngSwitchCase="report.status === AuditReportStatus.PENDING">
                    <span data-identifier="auditreport-pending" class="text-muted">{{ report.status | titlecase }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="report.status === AuditReportStatus.EMPTY">
                    <fa-icon [icon]="faCircleExclamation" class="fa-circle-exclamation me-1"></fa-icon>{{ emptyFileMessage }}
                </ng-container>
                <ng-container *ngSwitchCase="report.status === AuditReportStatus.FAILED">
                    <fa-icon [icon]="faCircleExclamation" class="fa-circle-exclamation me-1"></fa-icon>{{ failureMessage }}
                </ng-container>
                <ng-container *ngSwitchCase="report.status === AuditReportStatus.COMPLETED">
                    <button data-identifier="auditreport-opencsv" class="audit-report-link"
                            (click)="openCsv(report.fileName)">{{ report.fileName }}
                    </button>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr *ngIf="!isLoading" data-identifier="no-records">
            <td [attr.colspan]="8">
                <lib-empty-state [message]="'No audit reports recorded.'"/>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer">
        <tr>
            <td [attr.colspan]="8" class="border-bottom-0 px-0 pt-3">
                <lib-pagination *ngIf="totalItems > 0"
                                [totalItems]="totalItems"
                                [currentPage]="currentPage"
                                [itemsPerPage]="itemsPerPage"
                                [firstPageIdentifier]="'auditreport-pagination-first'"
                                [previousPageIdentifier]="'auditreport-pagination-previous'"
                                [currentPageIdentifier]="'auditreport-pagination-pagenumber'"
                                [nextPageIdentifier]="'auditreport-pagination-next'"
                                [lastPageIdentifier]="'auditreport-pagination-last'"
                                [viewByIdentifier]="'auditreport-pagination-viewby'"
                                (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                (changeCurrentPage)="onChangeCurrentPage($event)">
                </lib-pagination>
            </td>
        </tr>
    </ng-template>
</p-table>
